import { app } from '@/feature/analytics/hooks/use-firebase-remote-config.web';
import { useActiveWalletStore } from '@/hooks/use-active-wallet';
import { Product } from '@/hooks/use-jurisdiction';
import { getAnalytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';

import { AnalyticsEvent } from './constants';
import { setFirebaseCustomSignal } from './hooks/use-firebase-remote-config';

const analytics = getAnalytics(app);

class BetrAnalytics {
    setUserId(userId: string) {
        setUserId(analytics, userId);
    }

    setUserProperties(properties: { [key: string]: string | null }) {
        setUserProperties(analytics, properties);
    }

    trackEvent(event: AnalyticsEvent, params?: { [key: string]: any }) {
        logEvent(analytics, event, params);
    }

    setConsent(_consent: boolean) {}

    trackProductEvent(event: AnalyticsEvent, params?: { [key: string]: any }) {
        const activeProduct = useActiveWalletStore.getState().activeWalletProduct;
        if (activeProduct !== Product.None) {
            const trackedEvent = `${activeProduct}_${event}`;
            logEvent(analytics, trackedEvent, params);
        }
    }

    trackScreenView(screen: string, params?: { [key: string]: any }) {
        logEvent(analytics, 'screen_view', {
            firebase_screen: screen,
            firebase_screen_class: screen,
            ...params,
        });
    }

    trackEntryPlaced(amount: number, entryId: string) {
        logEvent(analytics, 'purchase', { value: amount, currency: 'USD', transaction_id: entryId });
    }

    setUserCustomSignal(key: string, value: string): Promise<void> {
        return setFirebaseCustomSignal(key, value);
    }
}

export default new BetrAnalytics();
